// A filter is set once it holds a value: a list with something in it, or a single value
// (`false` included: "without documents" filters too).
export const isFilterSet = (value) =>
  Array.isArray(value) ? value.length > 0 : value !== null && value !== undefined && value !== '';

// How many of these filters are set: the "Filtres (N)" of a phone's filter bar.
export const countSetFilters = (values) => values.filter(isFilterSet).length;
